import React, { useState } from 'react';
import { Button, Stack } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

import CustomTextField from '../../../components/forms/theme-elements/CustomTextField';
import CustomFormLabel from '../../../components/forms/theme-elements/CustomFormLabel';
import toast from 'react-hot-toast';

const AuthForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/v2/forgotpassword`, {
        email
      });

      if (response.data.status === 'Success') {
        toast.success(response.data.message);
        navigate('/auth/login');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Stack mt={4} spacing={2} component="form" onSubmit={handleSubmit}>
        <CustomFormLabel htmlFor="reset-email">Email Address</CustomFormLabel>
        <CustomTextField 
          id="reset-email" 
          variant="outlined" 
          fullWidth 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
        />

        <Button 
          color="primary" 
          variant="contained" 
          size="large" 
          fullWidth 
          type="submit"
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Reset Password'}
        </Button>
        
        <Button 
          color="primary" 
          size="large" 
          fullWidth 
          component={Link} 
          to="/auth/login"
        >
          Back to Login
        </Button>
      </Stack>
    </>
  );
};

export default AuthForgotPassword;